<script>
    import { IconStarFilled, IconStarHalfFilled } from '@tabler/icons-svelte';
    import { Ratings } from '@skeletonlabs/skeleton';

    export let maxValue = 5;
    export let value = 0;
    export let interactive = false;
    export let size = 20
    export let clickHandler = () => {};
    let starRating, starColour;

    function roundHalf(num) {
        const rounded = Math.round(num * 2) / 2;
        // never really round to 5.0, leave it at whatever it is
        if (rounded === 5.0) {
            return num;
        }
        return rounded;
    }

    $: starRating = value === 0 ? 0 : roundHalf((value / maxValue) * 5.0);
    $: starColour =
        starRating >= 4.0 ? 'text-lime-500' : starRating >= 2.0 ? 'text-amber-500' : starRating === 0 ? 'text-gray-500' : 'text-red-400';
</script>

<Ratings value={starRating} max={5} interactive={interactive} on:icon={clickHandler} spacing='space-x-1'>
    <svelte:fragment slot='empty'>
        <IconStarFilled {size} stroke={1.5} class='text-neutral-300' />
    </svelte:fragment>
    <svelte:fragment slot='half'>
        <IconStarHalfFilled {size} stroke={1} class='{starColour}'  />
    </svelte:fragment>
    <svelte:fragment slot='full'>
        <IconStarFilled {size} stroke={1} class={starColour} />
    </svelte:fragment>
</Ratings>